import { SdgRoutes } from '@igo2/sdg-common';

import { WithAuthGuard, WithProfilsGuard } from './core/guards';
import { authRoutes } from './pages/auth/auth.routes';
import { portalRoutes } from './pages/portal/portal.routes';

export const routes: SdgRoutes = [
  { path: '', redirectTo: '', pathMatch: 'full', hidden: true },
  { path: 'auth', children: authRoutes, hidden: true },
  {
    path: '',
    loadComponent: () =>
      import('./pages/portal/portal.component').then((m) => m.PortalComponent),
    children: portalRoutes,
    canActivate: [WithAuthGuard, WithProfilsGuard],
    hidden: true
  }
  // TODO
  // {
  //   path: '**',
  //   // title: AppTitleResolver,
  //   // data: { [RouteTranslateKey]: 'notFound.breadcrumbTitle' },
  //   loadComponent: () =>
  //     import('./pages/not-found/not-found.component').then(
  //       (m) => m.NotFoundComponent
  //     )
  // }
];
